import React from "react";
import { Form, Row, Col, Button } from "antd";

// component
import FormEmail from "./form_email";
import FormPassword from "./form_password";
import FormPasswordConfirm from "./form_password_confirm";
// redux

import { useSignUp } from "hook/useAuth";

const RegisterSection = () => {
  // -------------------------- STATE --------------------------
  const { loading, handleSentMail } = useSignUp();
  const [form] = Form.useForm();
  // -------------------------- REDUX --------------------------

  // -------------------------- FUNCTION --------------------------
  const onFinish = (values) => {
    handleSentMail({ values });
  };
  // -------------------------- MAIN --------------------------
  return (
    <Form
      name="normal_login"
      initialValues={{ remember: true }}
      autoComplete="off"
      form={form}
      onFinish={onFinish}
    >
      <Row gutter={[16, 0]}>
        <Col xl={24} lg={24} md={24} xs={24}>
          <FormEmail disabled={loading} />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <FormPassword signup={true} disabled={loading} />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <FormPasswordConfirm disabled={loading} />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
            style={{ width: "100%", marginBottom: 10 }}
            loading={loading}
          >
            Đăng Ký
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default RegisterSection;
